module.exports = __webpack_public_path__ + "img/2.9d546ce9.png";